// 接入天眼
// 目前只接入商家侧，观察数据一段时间后，为每个项目接入
// 2023-12-04 天眼替换为 Omega

import { SailingRaven } from '@didi/sailing-data-tools';
import { env } from '@/utils';

const initSailingRaven = () => {
  try {
    const NODE_ENV = process.env.NODE_ENV;
    const VUE_APP_BUILD_ENV = process.env.VUE_APP_BUILD_ENV;
    const IS_PRO = NODE_ENV === 'production' && VUE_APP_BUILD_ENV !== 'soda';
    window.$sailingRaven = new SailingRaven({
      Omega: window.Omega,
      autoTrack: IS_PRO,
    });
  } catch (err) {
    console.log('初始化天眼监控失败'.concat(err));
  }
};

const requestTrackStart = (config) => {
  if (window.$sailingRaven && config.url) {
    try {
      const { data, params, url } = config;
      const reqParams = params || data;
      const reqUrl = `${url}/${reqParams.api}`;
      return window.$sailingRaven.trackRequest.start(reqUrl, reqParams);
    } catch (err) {
      console.log('天眼监控请求失败 start'.concat(err));
    }
  }
};

/**
 * @name 获取traceId，每个项目traceId字段不同
 * @returns traceId
 */
const getTrackId = (data) => {
  const traceIdKeys = ['traceId', 'trace', 'requestId'];
  for (let i = 0; i < traceIdKeys.length; i++) {
    const key = traceIdKeys[i];
    if (data[key]) {
      return data[key];
    }
  }
  return '';
};

const requestTrackEnd = (response, reason = '') => {
  if (window.$sailingRaven) {
    try {
      const { config, data = {} } = response;
      const traceId = getTrackId(data);
      // 没有traceId，当做失败
      window.$sailingRaven.trackRequest.end(config.reqRavenId, traceId, Number(!!traceId), reason);
    } catch (err) {
      console.log('天眼监控发送请求失败'.concat(err));
    }
  }
};

export { initSailingRaven, requestTrackStart, requestTrackEnd };
